<!-- section template -->
<template>
  <div :class="$style.orderToggle">
    <div v-if="isShow">
      <ul :class="$style.orderToggleList">
        <li v-for="(item, index) in orderList" :key="`orderToggleList-${index}`" class="orderToggleList__item">
          <OrderReservationInfo :item="item" />
          <ul :class="$style.footList">
            <li v-for="(footItem, index2) in item.foot" :key="`footList-${index2}`" class="footList__item" :class="footItem.class">
              <template v-if="!footItem.type || footItem.type === 'button'">
                <BaseButton :class="footItem.buttonClass" @click="footItem.onClick()">
                  <span v-html="footItem.text"></span>
                </BaseButton>
              </template>
              <template v-if="footItem.type === 'dropdown'">
                <el-dropdown :hide-on-click="false" placement="bottom-start" class="w-100">
                  <BaseButton :class="footItem.buttonClass" @click.stop.prevent>
                    <span v-html="footItem.text"></span>
                  </BaseButton>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(dropdownItem, index3) in footItem.dropdown" :key="`dropdownItem-${index3}`" :class="dropdownItem.class" @click.native="dropdownItem.onClick()">
                      <span v-html="dropdownItem.text"></span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <BaseButton class="isStyleWhite isFull" :class="$globalIsDingBeauty ? '' : 'isRadius'" @click="isShow = !isShow">
      <template v-if="isShow"> 隱藏所有訂單<i class="fal fa-chevron-up pl-2"></i> </template>
      <template v-else> 顯示所有訂單 <i class="fal fa-chevron-down pl-2"></i> </template>
    </BaseButton>
  </div>
</template>

<script>
import formatDate from '@utils/format-date'
import { formatOrder } from '@utils/format-order'
import formatPrice from '@utils/format-price'

export default {
  components: {
    OrderReservationInfo: () => import('@components/Order/OrderReservationInfo'),
  },
  props: {
    orderList: {
      type: Array,
      default: () => {
        return [
          {
            id: '963f4023-a0e4-420e-9cb5-902e01abefd5',
            orderNo: 'JTAIL2107230001DQU0EADD3F',
            parentId: '95e92570-fd84-4da9-9534-f641508bc0c6',
            status: 0,
            fullName: '測試員',
            total: 200,
            payTotal: 0,
            unpaidTotal: 0,
            paymentMethod: 'Cash',
            paymentExpiredDate: null,
            createdDate: '2021-08-06 13:49:14',
            paidDate: '2021-08-17 14:20:21',
            cancelDate: '2021-08-06 13:49:55',
            addItems: [
              {
                title: '精油按摩',
                status: 0,
                basePrice: 200,
                price: 200,
                total: 200,
              },
            ],
            store: {
              title: '台北店',
            },
          },
        ]
      },
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  methods: {
    formatDate,
    formatOrder,
    formatPrice,
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.orderToggle {
  margin-bottom: 0.5rem;

  :global {
    .orderToggle {
      &__title {
        padding: 0.5rem 0;
        margin-bottom: 1rem;
        font-size: 0.75rem;
        text-align: center;
        background-color: rgba($color-secondary, 0.1);
      }
    }
  }
}

.orderToggleList {
  @include list-unstyled;

  margin-bottom: 1rem;

  :global {
    .orderToggleList {
      &__item {
        // padding: 1rem 1.5rem;

        &:not(:last-child) {
          // border-bottom: $color-gray-4 1px solid;
          margin-bottom: 1.125rem;
        }
      }
    }
  }
}

.footList {
  background: #fff;
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  :global {
    .footList {
      &__item {
        padding: 0 0.5rem 1rem;
        background: #fff;
      }

      &__title {
        @include unstyled;
      }

      &__text {
        @include unstyled;
      }
    }
  }
}
// .addItemList {
//   @include list-unstyled;

//   margin-bottom: 0;
//   font-size: 0.75rem;

//   :global {
//     .addItemList {
//       &__item {
//         line-height: 1.75;
//       }
//     }
//   }
// }
</style>
